import { createContext, FC, ReactNode } from 'react';

export type ICreateStatusContext = {
  id?: string;
  onSucceed: () => void;
  onCancel: () => void;
};

const defaultValues: ICreateStatusContext = {
  onSucceed: () => {},
  onCancel: () => {},
};

export const CreateStatusContext = createContext<ICreateStatusContext>(defaultValues);

export const CreateStatusProvider: FC<Partial<ICreateStatusContext> & { children?: ReactNode }> = ({ children, id, onSucceed = defaultValues.onSucceed, onCancel = defaultValues.onCancel }) => {
  return <CreateStatusContext.Provider value={{ id, onSucceed, onCancel }}>{children}</CreateStatusContext.Provider>;
};
